import React from 'react'
import { connect } from 'react-redux'
import { setUserInfo } from '../libs/action'
import { Api } from '../libs/api'
import Comment from './view/comment'
import Winners from './view/winners'
import WinnerNoti from './view/winnerNoti'
import ShareLayer from '../../common/share_layer'
import SEO from 'common/components/seo/Seo'

class View extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            vdata: {},
            snsPop: false,
        }
    }

    componentDidMount() {
        Api.getEventDetail(this.props.match.params.idx_cat_evt).then(response => {
            if (response.data.code === '200') {
                this.setState({ vdata: response.data.data })
            }
        })
        Api.getUserInfo().then(rst => {
            if (rst.data.code === 200) {
                if (rst.data.isLogin) {
                    this.props.setUserInfo(rst.data.result)
                } else {
                    window.location.href = 'https://sso.pping.kr'
                }
            }
        })
    }

    dateSlice = d => {
        const dt = d.split(' ')
        return dt[0]
    }

    handleShare = () => {
        const { snsPop } = this.state
        this.setState({ snsPop: !snsPop })
    }

    render() {
        const vd = this.state.vdata
        const sp = this.state.snsPop
        const userInfo = this.props.userInfo ? this.props.userInfo : { user_idx: 0 }
        const shareUrl = `https://event.pping.kr${this.props.location.pathname}`
        const evtInfo = vd.eventInfo ? vd.eventInfo[0] : false

        let eventTitle = (
            <img
                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${evtInfo.idx_cat_evt}/img/1904.jpg`}
                alt="이벤트 이미지"
            />
        )

        if (evtInfo.f_tit > 0) {
            // console.log(this.state.width)
            const iFrameWidth = evtInfo.height_tit_p
            // if (this.state.width < 1210) {
            //     iFrameWidth = evtInfo.height_tit_m
            // }
            eventTitle = (
                <iframe
                    ref={node => (this.node = node)}
                    src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${evtInfo.idx_cat_evt}/index.html`}
                    title="이벤트 이미지"
                    style={{ width: '1190px', height: iFrameWidth }}
                    className="event_title_frame"
                    scrolling="no"
                    allowFullScreen="allowfullscreen"
                    mozallowfullscreen="mozallowfullscreen"
                    msallowfullscreen="msallowfullscreen"
                    oallowfullscreen="oallowfullscreen"
                    webkitallowfullscreen="webkitallowfullscreen"
                    allow="autoplay"
                />
            )
        }

        return evtInfo ? (
            <React.Fragment>
                <SEO
                    title={`${evtInfo.nm_evt} 이벤트 당첨자 발표 : 행복쇼핑 가격비교`}
                    description={`${evtInfo.nm_evt} 이벤트 당첨자 발표 : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑"`}
                    ogTitle={`${evtInfo.nm_evt} 이벤트 당첨자 발표 : 행복쇼핑 가격비교`}
                    ogSiteName={`${evtInfo.nm_evt} 이벤트 당첨자 발표 : 행복쇼핑 가격비교`}
                />
                {sp && (
                    <ShareLayer
                        idx_cat_evt={evtInfo.idx_cat_evt}
                        title={vd.eventSnsTxt.fb_description}
                        description={vd.eventSnsTxt.fb_title}
                        image={`${process.env.REACT_APP_CDN_IMG}/img_static/img_evt/${
                            evtInfo.idx_cat_evt
                        }/img_sns/fb_1200_625.jpg`}
                        url={shareUrl}
                        onClose={this.handleShare}
                    />
                )}
                <section className="evtviewST">
                    <article className="evtTit">
                        <div className="evtTitle">
                            <strong>{evtInfo.nm_evt}</strong>
                        </div>
                        <button type="button" className="rightBtn icon-share" onClick={this.handleShare} />
                        <div className="evtDateInfo">
                            <strong>기간</strong>{' '}
                            <font>
                                {this.dateSlice(evtInfo.dt_st)} ~ {this.dateSlice(evtInfo.dt_ed)}
                            </font>
                            {evtInfo.dt_win && (
                                <React.Fragment>
                                    <strong>당첨자 발표일</strong>
                                    <font> {this.dateSlice(evtInfo.dt_win)}</font>
                                </React.Fragment>
                            )}
                            {/* <strong>조회수</strong> <font>{evtInfo.cnt_hit}</font> */}
                        </div>
                    </article>
                    <article className="evtMainCon">
                        <div className="evtMimg">{eventTitle}</div>
                        <Winners idx={this.props.match.params.idx_cat_evt} />
                        <WinnerNoti data={vd.eventInfo[0]} />
                    </article>
                    <Comment evtid={evtInfo.idx_cat_evt} user={userInfo} />
                    <article className="toListBtns">
                        <a href="../" className="styWBg">
                            당첨자 발표 목록
                        </a>
                    </article>
                </section>
            </React.Fragment>
        ) : (
            <p className="box-loading" />
        )
    }
}
const stateData = state => {
    return {
        userInfo: state.user.userInfo,
    }
}

const dispatchData = dispatch => {
    return {
        setUserInfo: userInfo => dispatch(setUserInfo(userInfo)),
    }
}

export default connect(
    stateData,
    dispatchData,
)(View)
